import { render, staticRenderFns } from "./FilterSelection.vue?vue&type=template&id=36352a64"
import script from "./FilterSelection.vue?vue&type=script&lang=js"
export * from "./FilterSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports